import angular from 'angular';

angular
  .module('cloudX')
  .controller('FieldConfigCtrl', ['resourceFactorySvc', 'ModalService', FieldConfigCtrl]);

function FieldConfigCtrl(resourceFactorySvc, ModalService) {
  var vm = this;
  vm.fields = [];

  vm.predicate = 'label';
  vm.reverse = false;

  vm.sort = function(predicate) {
    vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
    vm.predicate = predicate;
  };

  vm.editField = function(field) {
    ModalService.showModal({
      template: require('./configFieldDialog.html'),
      controller: 'ConfigFieldDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        field: field,
        fields: vm.fields,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result) {
          var index = vm.fields.indexOf(field);
          if (~index) vm.fields[index] = result;
        }
      });
    });
  };
  vm.addField = function() {
    ModalService.showModal({
      template: require('./configFieldDialog.html'),
      controller: 'ConfigFieldDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        field: {},
        fields: vm.fields,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result) vm.fields.push(result);
      });
    });
  };

  vm.reload = function() {
    vm.fields = resourceFactorySvc.get('field').query();
  };
  vm.reload();
}
